module.exports = __webpack_public_path__ + "static/media/_AmountSelection.933c4e4a.scss";


//////////////////
// WEBPACK FOOTER
// ./src/routes/Cob/views/AmountSelectionSwishMC/_AmountSelection.scss
// module id = 439
// module chunks = 0